; (function ($, _) {
    var common = require('./common');
    // var ad = require('./modules/ad');
    var fullColumnAd = require('./advertisement/full_column');
    var api = require('./modules/xl_api');
    var stat = require('./modules/stat');
    var comments = require('./modules/video_comments_old');
    var widgets = require('./modules/widgets');
    var DoubanRate = require('./modules/douban_rate');
    var defautSrcBinding = require('./modules/img_default_src_binding');

    var movieid = common.getParameter('movieid');
    var entrypage = common.getParameter('entrypage');
    var direct = common.getParameter('direct');
    var entry = common.getParameter('entry');
    var encodedUrl = encodeURIComponent(window.location.href);

    /**
     * 视频详情页
     * @class VideoDetail
     * @constructor
     */
    var App = {
        /**
         * 模块初始化
         * @method init
         */
        init: function () {
            var attr2 = '';
            this.initUI()
                .then(function () {
                    // 豆瓣评分
                    DoubanRate.renderAll();
                    comments.init({
                        $container: $('.com_list_des'),
                        $textarea: $('.area_com'),
                        $comBtn: $('.btn_com'),
                        template: _.template($('#comment-list-tpl').html()),
                        request: 'http://in.xl9.xunlei.com/index.php/comment/',
                        movieid: movieid,
                        length: 5,
                        comCallback: function () {
                            stat.trackEvent('movie_detailpage_addcomment', movieid, 'xl9');
                        }
                    });
                });
            this.eventBinding();

            /**
             * 资源详情页展示
             * 
             * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
             * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,
             *       hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,
             *       onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend;
             * url:页面url(需要urlencode)
             * movieid:资源id"
             */
            stat.trackEvent({
                key: 'right_area',
                attr1: 'moviedetail_page_show',
                extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl + ',movieid=' + movieid
            });
        },

        /**
         * 界面初始化
         * @method initUI
         */
        initUI: function () {
            fullColumnAd.init(1011, '.banner');
            stat.trackEvent('bannerads_show', 'changshipinxiangqing');
            if (!movieid) {
                return false;
            }

            return $.ajax({
                url: 'http://in.xl9.xunlei.com/index.php/movie/info',
                dataType: 'jsonp',
                data: {
                    movieid: movieid
                },
                success: function (json) {
                    if (json.errno != 0) {
                        return false;
                    }

                    var data = json.data;
                    var title = data.title;
                    App.breadRender(title);
                    App.videoIntroRender(data);
                    App.recommendRender(data);
                    defautSrcBinding();
                    App.videoIntroBinding();
                },
                error: function (res, err) { }
            });
        },

        /**
         * 事件绑定
         * @method eventBinding
         */
        eventBinding: function () {
            this.switchPlaySourceBinding();
            widgets.hoverBinding();
            common.pageShowBinding();
            
            $('.fav_list').on('click', 'a', function () {
                var $cont = $(this).closest('li');
                var movieid = $cont.data('movieid');
                stat.favorCollection(movieid);
            });

            $('.detail')
                // 搜资源
                .on('click', '.btn_res', function () {
                    var $cont = $(this).closest('.detail_main');
                    var val = $cont.find('.name').text();
                    /**
                     * 资源详情页点击统计
                     * 
                     * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
                     * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend-资源详情页推荐位;
                     * url:页面url(需要urlencode)
                     * movieid
                     * button:按钮名称,online-在线观看,search-搜资源，recommend-推荐资源，viewcomment-评论，like-点赞,sendcomment-发送评论
                     * target:跳转目标，需urlencode，在线看为跳转url，搜资源和推荐资源为电影名称，其他该字段为空字符串"
                     */
                    stat.trackEvent({
                        key: 'right_area',
                        attr1: 'moviedetail_page_click',
                        extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl 
                        + ',movieid=' + movieid + ',button=search,target=' + val
                    });
                    common.xiutanHandler(val);
                    return false;
                })
                // 点赞
                .on('click', '[data-role="praise"]', function () {
                    stat.trackEvent('movie_detailpage_praise');
                    common.login_from_praise = true;
                    comments.praiseHandler($(this), movieid);
                    /**
                     * 资源详情页点击统计
                     * 
                     * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
                     * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend-资源详情页推荐位;
                     * url:页面url(需要urlencode)
                     * movieid
                     * button:按钮名称,online-在线观看,search-搜资源，recommend-推荐资源，viewcomment-评论，like-点赞,sendcomment-发送评论
                     * target:跳转目标，需urlencode，在线看为跳转url，搜资源和推荐资源为电影名称，其他该字段为空字符串"
                     */
                    stat.trackEvent({
                        key: 'right_area',
                        attr1: 'moviedetail_page_click',
                        extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl 
                        + ',movieid=' + movieid + ',button=like,target='
                    });
                    return false;
                })
                // 评论
                .on('click', '[data-role="comments"]', function () {
                    comments.toCommenAnchor(200);
                    /**
                     * 资源详情页点击统计
                     * 
                     * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
                     * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend-资源详情页推荐位;
                     * url:页面url(需要urlencode)
                     * movieid
                     * button:按钮名称,online-在线观看,search-搜资源，recommend-推荐资源，viewcomment-评论，like-点赞,sendcomment-发送评论
                     * target:跳转目标，需urlencode，在线看为跳转url，搜资源和推荐资源为电影名称，其他该字段为空字符串"
                     */
                    stat.trackEvent({
                        key: 'right_area',
                        attr1: 'moviedetail_page_click',
                        extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl 
                        + ',movieid=' + movieid + ',button=viewcomment,target='
                    });
                    return false;
                })
                // 在线观看
                .on('click', '.btn_view', function () {
                    /**
                     * 资源详情页点击统计
                     * 
                     * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
                     * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend-资源详情页推荐位;
                     * url:页面url(需要urlencode)
                     * movieid
                     * button:按钮名称,online-在线观看,search-搜资源，recommend-推荐资源，viewcomment-评论，like-点赞,sendcomment-发送评论
                     * target:跳转目标，需urlencode，在线看为跳转url，搜资源和推荐资源为电影名称，其他该字段为空字符串"
                     */
                    stat.trackEvent({
                        key: 'right_area',
                        attr1: 'moviedetail_page_click',
                        extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl 
                        + ',movieid=' + movieid + ',button=online,target=' + encodeURIComponent(this.href)
                    });
                })
                // 广告
                .on('click', 'div.banner a', function () {
                    stat.trackEvent('bannerads_click', 'changshipinxiangqing');
                })
                .on('click', '.JS-recommend', function () {
                    var movieTitle = $(this).find('.name').text();
                    /**
                     * 资源详情页点击统计
                     * 
                     * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
                     * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend-资源详情页推荐位;
                     * url:页面url(需要urlencode)
                     * movieid
                     * button:按钮名称,online-在线观看,search-搜资源，recommend-推荐资源，viewcomment-评论，like-点赞,sendcomment-发送评论
                     * target:跳转目标，需urlencode，在线看为跳转url，搜资源和推荐资源为电影名称，其他该字段为空字符串"
                     */
                    stat.trackEvent({
                        key: 'right_area',
                        attr1: 'moviedetail_page_click',
                        extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl 
                        + ',movieid=' + movieid + ',button=recommend,target=' + movieTitle
                    });
                });


                $('.btn_com').click(function(){
                    /**
                     * 资源详情页点击统计
                     * 
                     * entrypage:进入资源详情页入口页,homepage-首页,moviedetail-资源详情页
                     * entry:进入资源详情页的点击位置:hotvideo_banner-热播视频TAB轮播图区域,hotvideo_film-热播视频TAB电影排行榜,hotvideo_tv-热播视频TAB电视剧排行榜,hotvideo_variety-热播视频TAB综艺排行榜,onlinevideo_film-在线视频TAB电影推荐区,onlinevideo_tv-在线视频TAB电视剧推荐区,onlinevideo_variety-在线视频TAB综艺推荐区,moviedetail_recommend-资源详情页推荐位;
                     * url:页面url(需要urlencode)
                     * movieid
                     * button:按钮名称,online-在线观看,search-搜资源，recommend-推荐资源，viewcomment-评论，like-点赞,sendcomment-发送评论
                     * target:跳转目标，需urlencode，在线看为跳转url，搜资源和推荐资源为电影名称，其他该字段为空字符串"
                     */
                    $(this).hasClass('dis') || stat.trackEvent({
                        key: 'right_area',
                        attr1: 'moviedetail_page_click',
                        extData: 'entrypage=' + entrypage + ',entry=' + entry + ',url=' + encodedUrl 
                        + ',movieid=' + movieid + ',button=sendcomment,target='
                    });
                })

            // loginStatusEmit在最后
            common.loginStatusEmit();
        },

        /**
         * 播放源切换
         * @method switchPlaySourceBinding
         */
        switchPlaySourceBinding: function () {
            $('.detail').on('click', '[data-role="hover-box"][data-hover-name="play-source"] > a', function () {
                var $this = $(this);
                var $displayBtn = $('.cho_from');
                var source = $this.data('source');
                var url = $this.data('play-url');
                var poster = $this.find('span').attr('class');
                $('[data-role="hover-box"][data-hover-name="play-source"] > a').show();
                $this.hide();
                $('.cho_from').attr('source', source)
                    .find('> span')
                    .attr('class', poster);
                $('.drop_from').hide();
                $('.btn_view').attr('href', url);
                return false;
            });
        },

        /**
         * 面包屑渲染
         * @method breadRender
         */
        breadRender: function (title) {
            var source = common.getParameter('source');
            var menuLvStr = '';
            if (direct == 'your_favor') {
                menuLvStr = '<span class="arrow">&gt;</span> <span> 猜你喜欢 </span>'
            } else if (direct == 'relations') {
                menuLvStr = '<span class="arrow">&gt;</span> <span> 相关推荐 </span>'
            } else if (/special_recommend/.test(direct)) {
                var arr = direct.split('|');
                menuLvStr = '<span class="arrow">&gt;</span> <a href="special.html"> 专题推荐 </a> <span class="arrow">&gt;</span> <a href="special_topic.html?topic=' + source + '">' + arr[1] + '</a> ';
            }
            $(document).attr('title', title);
            $('.bread').html(
                '<span> 首页 </span> ' +
                menuLvStr +
                '<span class="arrow">&gt;</span> ' +
                '<span>' + title + '</span> '
            );
        },

        videoFromClass: {
            'kankan': 'fav_kankan',
            'iqiyi.com': 'fav_qiyi',
            'youku.com': 'fav_youku',
            'letv.com': 'fav_letv',
            'pps.tv': 'fav_pps',
            'tudou.com': 'fav_tudou',
            'pptv.com': 'fav_pptv',
            'sohu.com': 'fav_sohu',
            'taomi.tv': 'fav_taomi',
            'qq.com': 'fav_qq',
            '56.com': 'fav_56',
            'baofeng.com': 'fav_baofeng',
            'funshion.com': 'fav_funshion',
            'wasu.com': 'fav_wasu',
            'hunantv.com': 'fav_hunantv',
            'cntv.com': 'av_cntv',
            'kankanvip': 'fav_kkvip'
        },

        /**
         * 视频简介渲染
         * @method videoIntroRender
         */
        videoIntroRender: function (data) {
            var template = _.template($('#video-detail-tpl').html());
            if (data.source_map) {
                data._source = data.source_map;
            }
            if (data.playlist) {
                // 将用户分享的播放源删掉
                data.playlist = _.reject(data.playlist, function (playitem) {
                    return playitem.source === 'vod';
                });
                data._source = data.playlist;
            }
            data.episode_indicator = 'last';
            if (data.type === 'tv' || data.type === 'documentary') {
                data.episode_indicator = 'first';
            }

            for (var i = 0; i < data.playlist.length; i++) {
                if (data.playlist[i].source === 'letv.com') {
                    var play = data.playlist.splice(i, 1)[0];
                    data.playlist.splice(0, 0, play);
                    break;
                } else if (data.playlist[i].source === 'youku.com') {
                    var play = data.playlist.splice(i, 1)[0];
                    if (data.playlist[0] && data.playlist[0].source === 'letv.com') {
                        data.playlist.splice(1, 0, play);
                    } else {
                        data.playlist.splice(0, 0, play);
                    }
                }
            }
            data.videoFromClass = App.videoFromClass;
            $('.detail').prepend(template(data));
        },

        /**
         * 视频简介渲染
         * @method videoIntroRender
         */
        videoIntroBinding: function () {
            var $desc = $('[data-role="description"]');
            var $btn = $('[data-role="spread-btn"]');
            var infos = $desc.text();
            var bMax = 200;
            var sMax = 150;
            var max = common.isBSWindow() ? bMax : sMax;
            if (infos.length > max) {
                var shortInfos = infos.substr(0, max) + '...';
                $desc.text(shortInfos);
                $btn.show()
                    .html('展开<span class="ico_arw_d"></span>');
                $btn.on('click', function () {
                    if ($btn.text() == '展开') {
                        $desc.text(infos);
                        $btn.html('收起<span class="ico_arw_d arw_up"></span>');
                    } else {
                        $desc.text(shortInfos);
                        $btn.html('展开<span class="ico_arw_d"></span>');
                    }
                    return false;
                });
                $(window).on('resize', function () {
                    if ($btn.text() == '展开') {
                        if (common.isBSWindow()) {
                            shortInfos = infos.substr(0, bMax) + '...';
                            $desc.text(shortInfos);
                        } else {
                            shortInfos = infos.substr(0, sMax) + '...';
                            $desc.text(shortInfos);
                        }
                    }
                });
            }
        },

        /**
         * 相关推荐渲染
         * @method recommendRender
         */
        recommendRender: function (data) {
            var template = _.template($('#guess-your-favor-tpl').html());
            $('.fav_list ul').html(template(data));
        }
    };

    // 页面入口
    $(function () {
        App.init();
    });

    if (typeof exports === 'object') {
        module.exports = {};
    }
})(jQuery, _);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/video_detail.js
// module id = 0
// module chunks = 10